export enum VisibilityEnum{
    PUBLIC='PUBLIC',
    PRIVE="PRIVE",
    SEMI_PRIVE="SEMI_PRIVE",
    RESTREINT="RESTREINT"
}